import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Button, Typography, Alert, Paper, BaseDialog, DialogActions } from '@metarouter-private/mr-mui';
import CopyToClipboard from 'app/components/CopyToClipboard';

export default function SecretDisplayModal({ open, onClose, hmacSecret }) {
  return (
    <BaseDialog
      DialogProps={{ open, onClose, maxWidth: 'md', fullWidth: true }}
      title="Webhook Created"
      content={
        <Stack spacing={2}>
          <Alert severity="warning">
            This is the only time the signing secret will be shown. Copy it now — it cannot be retrieved later.
          </Alert>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary">
              HMAC Signing Secret
            </Typography>
            <Paper variant="outlined" sx={{ p: 1.5, backgroundColor: 'grey.50' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="body2" fontFamily="monospace" sx={{ userSelect: 'all' }}>
                  {hmacSecret}
                </Typography>
                <CopyToClipboard text={hmacSecret} />
              </Stack>
            </Paper>
          </Stack>
        </Stack>
      }
      actions={
        <DialogActions>
          <Button variant="contained" onClick={onClose}>
            Done
          </Button>
        </DialogActions>
      }
    />
  );
}

SecretDisplayModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  hmacSecret: PropTypes.string.isRequired,
};
